import React from 'react';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';
import { ListItemButton, ListItemIcon, ListItemText, useMediaQuery, Collapse } from '@mui/material';
import { useLocation } from 'react-router-dom';
import routes from '../../../Utils/routes';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import { useStyles } from '../styles';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import { ReactComponent as Events } from '../../../Assets/icons/Events.svg';
import { ReactComponent as AccountCircleOutlinedIcon } from '../../../Assets/icons/MyProfile.svg';
import { ReactComponent as AccountCircleOutlinedIconSelect } from '../../../Assets/icons/MyProfileSelect.svg';
import { ReactComponent as EventsSelect } from '../../../Assets/icons/EventsSelect.svg';
import { ReactComponent as Homeicon } from '../../../Assets/icons/Home.svg';
import { ReactComponent as HomeiconSelect } from '../../../Assets/icons/HomeSelect.svg';
import { ReactComponent as Feed } from '../../../Assets/icons/Feed.svg';
import { ReactComponent as FeedSelect } from '../../../Assets/icons/FeedSelect.svg';
import { ReactComponent as Jobs } from '../../../Assets/icons/Job.svg';
import { ReactComponent as JobsSelect } from '../../../Assets/icons/JobSelect.svg';
import { ReactComponent as MentorShip } from '../../../Assets/icons/MentorShip.svg';
import { ReactComponent as MentorShipSelect } from '../../../Assets/icons/MentorShipSelect.svg';
import { ReactComponent as FundRaise } from '../../../Assets/icons/FundRaise.svg';
import { ReactComponent as FundRaiseSelect } from '../../../Assets/icons/FundRaiseSelect.svg';
import { ReactComponent as Networks } from '../../../Assets/icons/Networks.svg';
import { ReactComponent as NetworksSelect } from '../../../Assets/icons/NetworksSelect.svg';
import { ReactComponent as InfoHubcopy } from '../../../Assets/icons/InfoHubcopy.svg';
import { ReactComponent as Survey } from '../../../Assets/icons/Survey.svg';
import { ReactComponent as SurveySelect } from '../../../Assets/icons/SurveySelect.svg';
import { ReactComponent as Service } from '../../../Assets/icons/Service.svg';
import { ReactComponent as ServiceSelect } from '../../../Assets/icons/ServiceSelect.svg';

import { ReactComponent as Logout } from '../../../Assets/icons/LogOut.svg';
interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
}

const SideNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const getFirstPath = pathname.split('/').filter((items: string) => items && items !== '');
  const is1980 = useMediaQuery('(max-width:1280px)');
  const [openInfoHub, setOpenInfoHub] = React.useState(false);
  const { logoutUser } = useContext(AuthContext);
const navigate = useNavigate();

  const sideNavContents = [
    {
      icon: (isActive: boolean) => (
        isActive
          ? <HomeiconSelect className={classes.listItemIcon} />
          : <Homeicon className={classes.listItemIconActive} />
      ),
      label: 'Home',
      link: routes.home,
      name: 'home',
    },
    {
      icon: (isActive: boolean) => (
        isActive ?
          <AccountCircleOutlinedIconSelect className={isActive ? classes.listItemIconActive : classes.listItemIcon} /> :
          <AccountCircleOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'My Profile',
      link: routes.myProfile,
      name: 'my%20Profile',
    },
    {
      icon: (isActive: boolean) => (
        isActive
          ? <FeedSelect className={classes.listItemIcon} />
          : <Feed className={classes.listItemIconActive} />
      ),
      label: 'Feed',
      link: routes.myFeed,
      name: 'my%20Feed',
    },
    {
      icon: (isActive: boolean) => (
        isActive
          ? <EventsSelect className={classes.listItemIcon} />
          : <Events className={classes.listItemIconActive} />
      ),
      label: 'Events',
      link: routes.events,
      name: 'events',
    },
    {
      icon: (isActive: boolean) => (
        isActive
          ? <JobsSelect className={classes.listItemIcon} />
          : <Jobs className={classes.listItemIconActive} />
      ),
      label: 'Jobs',
      link: routes.jobs,
      name: 'jobs',
    },
    {
      icon: (isActive: boolean) => (
        isActive
          ? <MentorShipSelect className={classes.listItemIcon} />
          : <MentorShip className={classes.listItemIconActive} />
      ),
      label: 'Mentorship',
      link: routes.mentorship,
      name: 'mentorship',
    },
    {
      icon: (isActive: boolean) => (
        isActive ?
          <FundRaiseSelect className={isActive ? classes.listItemIconActive : classes.listItemIcon} /> :
          <FundRaise className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Fundraise',
      link: routes.fundraise,
      name: 'fundraise',
    },
    {
      icon: (isActive: boolean) => (
        isActive
          ? <NetworksSelect className={classes.listItemIcon} />
          :
          <Networks className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Network',
      link: routes.network,
      name: 'network',
    },
    {
      icon: (isActive: boolean) => (
        <GroupsOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Groups',
      link: routes.groups,
      name: 'groups',
    },
    {
      icon: (isActive: boolean) => (
        <InfoHubcopy className={classes.listItemIcon} />
      ),
      label: 'Info Hub',
      name: 'infohub',
      isDropdown: true,
      children: [
        {
          label: 'Photos',
          link: routes.photos,
          name: 'photos',
          icon: (isActive: boolean) => (
            <PermMediaOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
          ),
        },
        {
          label: 'Business Directory',
          link: routes.businessdirectory,
          name: 'business%20directory',
          icon: (isActive: boolean) => (
            <ComputerOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
          ),
        },
        {
          label: 'Resources',
          link: routes.resources,
          name: 'resources',
          icon: (isActive: boolean) => (
            <MenuBookIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
          ),
        },
      ],
    },
    {
      icon: (isActive: boolean) => (
        isActive
          ? <SurveySelect className={classes.listItemIcon} />
          : <Survey className={classes.listItemIconActive} />
      ),
      label: 'Survey',
      link: routes.survey,
      name: 'survey',
    },
    {
      icon: (isActive: boolean) => (
        isActive
          ? <ServiceSelect className={classes.listItemIcon} />
          : <Service className={classes.listItemIconActive} />
      ),
      label: 'Service & Support',
      link: routes.service,
      name: 'service%20&%20support',
    },
    {
      icon: (isActive: boolean) => (
        <Logout className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Logout',
      link: routes.landingpage,
      name: 'logout',
    },
  ];
  const isInfoHubActive = sideNavContents
    .find((item: any) => item.isDropdown)
    ?.children?.some((subItem: any) => getFirstPath[0] === subItem.name);
const [hoveredItem, setHoveredItem] = React.useState<string | null>(null);

  return (
    <>
      {is1980 ? (
        <div style={{ overflow: 'auto', height: `calc(100vh - 220px)` }} className="scrollbar-cusgray">
          {sideNavContents.map((item: any, index) => {
            if (item.isDropdown) {
              return (
                <div key={item.label}>
                  <ListItemButton onClick={() => setOpenInfoHub(!openInfoHub)} className={classes.listItemButton}>
                    {item.icon && (
                      <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>
                        {item.icon(isInfoHubActive)}
                      </ListItemIcon>
                    )}
                    <ListItemText
                      primary={item.label}
                      className={`${classes.listItemText}`}
                    />
                    {openInfoHub ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>

                  <Collapse in={openInfoHub} timeout="auto" unmountOnExit>
                    {item.children.map((subItem: any) => {
                      const isSubItemActive = getFirstPath[0] === subItem.name;
                      return (
                        <ListItemButton
                          key={subItem.label}
                          onClick={() => handleListClick(subItem.link, index)}
                          className={`${classes.listItemButton} ${isSubItemActive && classes.listItemButtonActive}`}
                          sx={{ pl: 4 }}
                        >
                          {subItem.icon && (
                            <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>
                              {subItem.icon(isSubItemActive)} {/* Render subheading icon */}
                            </ListItemIcon>
                          )}
                          <ListItemText
                            primary={subItem.label}
                            className={`${classes.listItemText} ${isSubItemActive && classes.listItemTextActive}`}
                          />
                        </ListItemButton>
                      );
                    })}
                  </Collapse>
                </div>
              );
            } else {
              return (
                <ListItemButton
                  key={item.label}
                  onClick={() => handleListClick(item.link, index)}
                  className={`${classes.listItemButton} ${getFirstPath[0] === item.name && classes.listItemButtonActive}`}
                >
                  <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>
                    {item.icon && item.icon(getFirstPath[0] === item.name)}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    className={`${classes.listItemText} ${getFirstPath[0] === item.name && classes.listItemTextActive}`}
                  />
                </ListItemButton>
              );
            }
          })}
        </div>
      ) : (
        <>
<div style={{ overflow: 'auto', height: 'calc(100vh - 260px)' }} className="scrollbar-cusgray">
{sideNavContents.slice(0, -1).map((item: any, index) => {
  const isItemActive = getFirstPath[0] === item.name;
  const isHovered = hoveredItem === item.name;
  const isActiveOrHovered = isItemActive || isHovered;

  if (item.isDropdown) {
    // dropdown logic unchanged below (optional to modify similarly)
    return (
      <div key={item.label}>
        <ListItemButton
          onClick={() => setOpenInfoHub(!openInfoHub)}
          onMouseEnter={() => setHoveredItem(item.name)}
          onMouseLeave={() => setHoveredItem(null)}
          sx={{
            backgroundColor: isActiveOrHovered ? '#2C60AA' : 'transparent',
            '&:hover': { backgroundColor: '#2C60AA' },
          }}
        >
          {item.icon && (
     <ListItemIcon sx={{ minWidth: '30px' }}>
  <div
    style={{
      filter: isActiveOrHovered ? 'brightness(0) invert(1)' : 'none',
      transition: 'filter 0.2s ease',
      display: 'flex',
      alignItems: 'center',
    }}
  >
    {item.icon && item.icon(isActiveOrHovered)}
  </div>
</ListItemIcon>


          )}
          <ListItemText
            primary={item.label}
            sx={{
              color: isActiveOrHovered ? '#FFFFFF' : '#000000',
              fontWeight: isActiveOrHovered ? '600' : '400',
            }}
          />
          {openInfoHub ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openInfoHub} timeout="auto" unmountOnExit>
          {item.children.map((subItem: any) => {
            const isSubItemActive = getFirstPath[0] === subItem.name;
            const isSubHovered = hoveredItem === subItem.name;
            const isSubActiveOrHovered = isSubItemActive || isSubHovered;

            return (
              <ListItemButton
                key={subItem.label}
                onClick={() => handleListClick(subItem.link, index)}
                onMouseEnter={() => setHoveredItem(subItem.name)}
                onMouseLeave={() => setHoveredItem(null)}
                sx={{
                  pl: 4,
                  backgroundColor: isSubActiveOrHovered ? '#2C60AA' : 'transparent',
                  '&:hover': { backgroundColor: '#2C60AA' },
                }}
              >
                {subItem.icon && (
                  <ListItemIcon sx={{ minWidth: '30px' }}>
                    {subItem.icon(isSubActiveOrHovered)} {/* 👈 sub-icons also swap */}
                  </ListItemIcon>
                )}
                <ListItemText
                  primary={subItem.label}
                  sx={{
                    color: isSubActiveOrHovered ? '#FFFFFF' : '#000000',
                    fontWeight: isSubActiveOrHovered ? '600' : '500',
                  }}
                />
              </ListItemButton>
            );
          })}
        </Collapse>
      </div>
    );
  } else {
    return (
      <ListItemButton
        key={item.label}
        onClick={() => handleListClick(item.link, index)}
        onMouseEnter={() => setHoveredItem(item.name)}
        onMouseLeave={() => setHoveredItem(null)}
        sx={{
          backgroundColor: isActiveOrHovered ? '#2C60AA' : 'transparent',
          color: isActiveOrHovered ? '#FFFFFF' : '#000',
          '&:hover': { backgroundColor: '#2C60AA', color: '#FFFFFF' },
        }}
      >
     <ListItemIcon sx={{ minWidth: '30px' }}>
  <div
    style={{
      filter: isActiveOrHovered ? 'brightness(0) invert(1)' : 'none',
      transition: 'filter 0.2s ease',
      display: 'flex',
      alignItems: 'center',
    }}
  >
    {item.icon && item.icon(isActiveOrHovered)}
  </div>
</ListItemIcon>


        <ListItemText
          primary={item.label}
          sx={{
            fontWeight: isActiveOrHovered ? '600' : '400',
            color: isActiveOrHovered ? '#FFFFFF' : '#000',
          }}
        />
      </ListItemButton>
    );
  }
})}

</div>


          <div>
            {/* Logout item */}
            {sideNavContents.slice(-1).map((item: any, index) => (
          <ListItemButton
  key={item.label}
  onClick={async () => {
    if (item.name === 'logout') {
      await logoutUser();
      navigate(routes.landingpage);
    } else {
      handleListClick(item.link, index);
    }
  }}
  onMouseEnter={() => setHoveredItem(item.name)}
  onMouseLeave={() => setHoveredItem(null)}
  sx={{
    marginTop: '-30px',
    backgroundColor: hoveredItem === item.name ? '#2C60AA' : 'transparent',
    color: hoveredItem === item.name ? '#FFFFFF' : '#000000',
    '&:hover': { backgroundColor: '#2C60AA', color: '#FFFFFF' },
  }}
>
  <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>
    <div
      style={{
        filter: hoveredItem === item.name ? 'brightness(0) invert(1)' : 'none',
        transition: 'filter 0.2s ease',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {item.icon && item.icon(getFirstPath[0] === item.name)}
    </div>
  </ListItemIcon>
  <ListItemText
    primary={item.label}
    sx={{
      color: hoveredItem === item.name ? '#FFFFFF' : '#000000',
      fontWeight: hoveredItem === item.name ? 600 : 400,
    }}
  />
</ListItemButton>

            ))}
          </div>
        </>
      )}
    </>
  );
};

export default SideNavTabs;
